import { render } from "./PagesCreate.vue?vue&type=template&id=1865ba02"
import script from "./PagesCreate.vue?vue&type=script&lang=js"
export * from "./PagesCreate.vue?vue&type=script&lang=js"

import "./PagesCreate.vue?vue&type=style&index=0&id=1865ba02&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__